module.exports = __webpack_public_path__ + "static/media/image46.3be5f265.jpg";